module.exports = __webpack_public_path__ + "static/media/savtym.b2c98812.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/authors/savtym.jpg
// module id = 1384
// module chunks = 0